import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { eur } from "@/components/excelVoce/format";
import { RegistrazioneDialog } from "./RegistrazioneDialog";
import { RegistroLista } from "./RegistroLista";
import { StoricoDialog } from "./StoricoDialog";
import { TIPO_LABEL, canEditRegistro } from "./labels";
import { FunzioniSpente, useFunzioniExcel } from "@/components/salE5/labels";

const Stat = ({ label, v, testid, cls = "" }) => (
  <div className="rounded-md border p-3" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
    <div className={`font-mono text-sm mt-1 ${cls}`}>{v}</div>
  </div>
);

const StatMateriali = ({ m }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-2" data-testid="materiali-fasi">
    <Stat label={`Ordinato (${m.ordinato.n} ordini)`} v={eur(m.ordinato.importo)} testid="fase-ordinato" />
    <Stat label="Consegnato" v={eur(m.consegnato)} testid="fase-consegnato" />
    <Stat label="Utilizzato = costo voci" v={eur(m.utilizzato)} testid="fase-utilizzato" cls="text-sky-800 font-semibold" />
    <Stat label="Giacenza in cantiere" v={eur(m.giacenza)} testid="fase-giacenza" cls="text-amber-700" />
  </div>
);

export const RegistroModulo = ({ cantiere, computoId, tipi, titolo }) => {
  const { user } = useAuth();
  const fx = useFunzioniExcel();
  const canEdit = canEditRegistro(user);
  const [regs, setRegs] = useState([]);
  const [conf, setConf] = useState(null);
  const [annullate, setAnnullate] = useState(false);
  const [dialog, setDialog] = useState(null);
  const [storico, setStorico] = useState(null);
  const load = () => {
    api.get(`/cantieri/${cantiere.id}/registro-effettivo`, { params: { computo_id: computoId, tipo: tipi.join(","), include_annullate: annullate } }).then((r) => setRegs(r.data));
    api.get(`/computi/${computoId}/registro-effettivo/confronto`).then((r) => setConf(r.data));
  };
  useEffect(() => { load(); }, [cantiere.id, computoId, annullate]);
  return (
    <Card data-testid={`registro-modulo-${tipi.join("-")}`}><CardContent className="p-4 sm:p-6 space-y-4">
      <FunzioniSpente st={fx} />
      <div className="flex flex-wrap items-center gap-2">
        <div className="mr-auto">
          <div className="text-xs uppercase tracking-widest text-sky-700 font-semibold">{titolo}</div>
          <p className="text-xs text-slate-500 mt-0.5">Registro unico del computo Excel: le stesse registrazioni compaiono nel dettaglio delle voci e nel Controllo costi.</p>
        </div>
        <label className="flex items-center gap-1.5 text-xs text-slate-600"><Checkbox checked={annullate} onCheckedChange={(v) => setAnnullate(!!v)} data-testid="registro-mostra-annullate" /> Mostra annullate</label>
        {canEdit && tipi.map((t) => <Button key={t} size="sm" onClick={() => setDialog({ tipo: t })} data-testid={`modulo-nuova-${t}`}><Plus className="h-3.5 w-3.5 mr-1" /> {TIPO_LABEL[t]}</Button>)}
      </div>
      {conf && tipi.includes("MATERIALE") && <StatMateriali m={conf.materiali} />}
      {conf && tipi.includes("NOLO") && Number(conf.non_attribuito.noli) > 0 && <p className="text-xs text-amber-700" data-testid="noli-non-attribuiti">Noli non ancora attribuiti alle voci: {eur(conf.non_attribuito.noli)}</p>}
      {conf && tipi.includes("MANODOPERA") && Number(conf.non_attribuito.manodopera_ore_h) > 0 && <p className="text-xs text-amber-700" data-testid="mdo-non-attribuita">Ore non ancora attribuite alle voci: {conf.non_attribuito.manodopera_ore_h} h ({eur(conf.non_attribuito.manodopera_ore)})</p>}
      <RegistroLista regs={regs} canEdit={canEdit} onEdit={(r) => setDialog({ tipo: r.tipo, initial: r })} onStorico={setStorico} onChanged={load} testid="modulo-registro-lista" />
      {dialog && <RegistrazioneDialog open onOpenChange={(o) => !o && setDialog(null)} cantiereId={cantiere.id} computoId={computoId} tipo={dialog.tipo} initial={dialog.initial} onSaved={load} />}
      <StoricoDialog regId={storico} onOpenChange={() => setStorico(null)} />
    </CardContent></Card>
  );
};
